var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.97 12.163c.902-1.907 3.772-5.77 8.025-5.97 3.675-.173 5.002.684 6.001 1.33.446.288.827.534 1.323.627 1.604.3 3.21-.05 4.163-.502.762-.361 1.254-.886 1.404-1.104-1.505-2.107-6.25-6.15-13.193-5.467-8.678.852-12.14 8.126-12.44 8.878-.24.602-.401 1.723-.451 2.208h5.166zm-3.261 6.671a2.71 2.71 0 1 0-.001-5.417 2.71 2.71 0 0 0-.001 5.417zm2.156-.15c.585-.285 1.755-1.184 1.755-2.508.001-1.325-1.102-2.258-1.654-2.559.318.335.953 1.315.953 2.559s-.703 2.19-1.054 2.508zm9.13 7.123c-4.254-.2-7.124-4.063-8.027-5.97H3.802c.05.485.21 1.606.451 2.208.3.752 3.762 8.026 12.44 8.878 6.943.683 11.688-3.36 13.193-5.467-.15-.218-.642-.743-1.404-1.104-.953-.451-2.559-.802-4.164-.501-.497.093-.878.34-1.324.628-.999.645-2.326 1.502-6 1.329z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCos);
export default __webpack_public_path__ + "static/media/COS.57e9517081e8162bc82436644557fc96.svg";
export { ForwardRef as ReactComponent };